/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetEventsHistoryResponseDto,
  SseControllerEvents429,
  SseControllerEventsParams,
  SseControllerGetEventsHistory429,
  SseControllerGetEventsHistoryParams
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * ⚠️ This endpoint uses Server-Sent Events (SSE), not standard request-response.

**Authentication (3 methods):**
1. **httpOnly cookie** (automatically sent after POST /auth/telegram)
   - Same-origin: works with default settings (SameSite=None)
   - Cross-origin: requires AUTH_COOKIE_SECURE=true + HTTPS in production
   - Configure via AUTH_COOKIE_* env vars (see .env.example)
2. **Query parameter**: `?token=YOUR_JWT` (fallback if cookies blocked)
   - Example: `/api/events?token=eyJhbGc...`
   - Works everywhere but less secure (token visible in URL)
3. **Authorization header**: Bearer token (requires EventSourcePolyfill library)

**Usage with EventSource (Unified Stream - Recommended):**
```javascript
// After successful login, cookie is set automatically
// This connects to BOTH personal and lobby events in one stream
const eventSource = new EventSource("/api/events", {
  withCredentials: true // Required for cookies
});

// Events include a "scope" field to distinguish between personal and lobby
eventSource.addEventListener("DONATION_RECEIVED", (e) => {
  const data = JSON.parse(e.data);
  if (data.scope === "personal") {
    // Handle personal notification
  } else if (data.scope === "lobby") {
    // Handle public lobby activity
  }
});
```

**Legacy usage (separate connections):**
```javascript
// Deprecated: requires 2 connections
const userEvents = new EventSource("/api/events?room=user");
const lobbyEvents = new EventSource("/api/events?room=lobby");
```

**Available rooms (optional parameter):**
- omit `room` parameter - Unified stream: personal + lobby events (recommended)
- `user` - Personal notifications only (legacy)
- `lobby` - Public activity events only (legacy)

**Event types:** All events are documented in Schemas (SseEventDto). Generate TypeScript types from swagger/json.
 * @summary Subscribe to Server-Sent Events (SSE)
 */
export const sseControllerEvents = (
    params?: SseControllerEventsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<null>(
      {url: `/events`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSseControllerEventsQueryKey = (params?: SseControllerEventsParams,) => {
    return [`/events`, ...(params ? [params]: [])] as const;
    }

    
export const getSseControllerEventsQueryOptions = <TData = Awaited<ReturnType<typeof sseControllerEvents>>, TError = null | null | null | SseControllerEvents429>(params?: SseControllerEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSseControllerEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sseControllerEvents>>> = ({ signal }) => sseControllerEvents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SseControllerEventsQueryResult = NonNullable<Awaited<ReturnType<typeof sseControllerEvents>>>
export type SseControllerEventsQueryError = null | null | null | SseControllerEvents429


export function useSseControllerEvents<TData = Awaited<ReturnType<typeof sseControllerEvents>>, TError = null | null | null | SseControllerEvents429>(
 params: undefined |  SseControllerEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sseControllerEvents>>,
          TError,
          Awaited<ReturnType<typeof sseControllerEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSseControllerEvents<TData = Awaited<ReturnType<typeof sseControllerEvents>>, TError = null | null | null | SseControllerEvents429>(
 params?: SseControllerEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sseControllerEvents>>,
          TError,
          Awaited<ReturnType<typeof sseControllerEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSseControllerEvents<TData = Awaited<ReturnType<typeof sseControllerEvents>>, TError = null | null | null | SseControllerEvents429>(
 params?: SseControllerEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Subscribe to Server-Sent Events (SSE)
 */

export function useSseControllerEvents<TData = Awaited<ReturnType<typeof sseControllerEvents>>, TError = null | null | null | SseControllerEvents429>(
 params?: SseControllerEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerEvents>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSseControllerEventsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve past SSE events with optional filtering by event type and scope.

**Scope filtering:**
- `lobby` - Public lobby activity events only
- `personal` - User-specific events only (filtered by current user)
- Omit scope to get both types

**Security:**
- Personal events are automatically filtered to current user
- Lobby events are public and visible to all authenticated users

**Use cases:**
- Load recent lobby activity when user first connects
- Show notification history to user
- Sync events that were missed while offline
 * @summary Get historical SSE events
 */
export const sseControllerGetEventsHistory = (
    params?: SseControllerGetEventsHistoryParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<GetEventsHistoryResponseDto>(
      {url: `/events/history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSseControllerGetEventsHistoryQueryKey = (params?: SseControllerGetEventsHistoryParams,) => {
    return [`/events/history`, ...(params ? [params]: [])] as const;
    }

    
export const getSseControllerGetEventsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError = null | SseControllerGetEventsHistory429>(params?: SseControllerGetEventsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSseControllerGetEventsHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>> = ({ signal }) => sseControllerGetEventsHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SseControllerGetEventsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>>
export type SseControllerGetEventsHistoryQueryError = null | SseControllerGetEventsHistory429


export function useSseControllerGetEventsHistory<TData = Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError = null | SseControllerGetEventsHistory429>(
 params: undefined |  SseControllerGetEventsHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sseControllerGetEventsHistory>>,
          TError,
          Awaited<ReturnType<typeof sseControllerGetEventsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSseControllerGetEventsHistory<TData = Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError = null | SseControllerGetEventsHistory429>(
 params?: SseControllerGetEventsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sseControllerGetEventsHistory>>,
          TError,
          Awaited<ReturnType<typeof sseControllerGetEventsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSseControllerGetEventsHistory<TData = Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError = null | SseControllerGetEventsHistory429>(
 params?: SseControllerGetEventsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get historical SSE events
 */

export function useSseControllerGetEventsHistory<TData = Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError = null | SseControllerGetEventsHistory429>(
 params?: SseControllerGetEventsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sseControllerGetEventsHistory>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSseControllerGetEventsHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



